import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Switch, Route, Redirect } from 'react-router-dom';
import { adminRoutes, superAdminRoutes } from './routes';
import SideDrawer from '../components/SideDrawer/SideDrawer';
import { verifyLogin } from '../helpers';
import PageContainer from '../components/PageContainer/PageContainer';

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    // Fill the window so the body background never shows under short pages.
    minHeight: '100vh',
    backgroundColor: 'var(--page-bg)',
  },
  routes: {
    width: '100%',
    minWidth: 0,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  hide: {
    display: 'none',
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9) + 1,
    },
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  content: {
    padding: theme.spacing(3),
  },
}));

export default function AdminRouter() {
  const { user } = verifyLogin();

  const routes = user.userRoleId === 1 ? superAdminRoutes : adminRoutes;
  const classes = useStyles();
  const [open, setOpen] = React.useState(true);

  // The main sidebar (navBar) leaves a body class that pads #root for its
  // width; Admin shows its own drawer instead, so remove that offset here.
  // navBar sets it again when the main screens mount.
  React.useEffect(() => {
    document.body.classList.remove('bez-nav-expanded', 'bez-nav-collapsed');
  }, []);

  const handleDrawerClose = () => {
    setOpen(!open);
  };
  return (
    <div className={classes.root}>
      <SideDrawer
        handleDrawerClose={handleDrawerClose}
        routes={routes}
        routesCategories={routes}
        logoText='Home Hub'
        image='bgImage'
        open={open}
        color='green'
      />
      <div className={classes.routes}>
        <PageContainer width='wide'>
          <Switch>
            {routes.map((prop, key) => {
              if (prop.layout === '/admin') {
                return (
                  <Route
                    path={prop.layout + prop.path}
                    component={prop.component}
                    key={key}
                  />
                );
              }
              return null;
            })}
            <Redirect from='/admin' to='/admin/users' />
          </Switch>
        </PageContainer>
      </div>
    </div>
  );
}
